import { render } from "./demandActionButton.vue?vue&type=template&id=c62becb2&scoped=true"
import script from "./demandActionButton.vue?vue&type=script&lang=js"
export * from "./demandActionButton.vue?vue&type=script&lang=js"

import "./demandActionButton.vue?vue&type=style&index=0&id=c62becb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c62becb2"

export default script